import * as React from 'react';
import {LandingTile} from './LandingTile';
import blazin from 'assets/img/landing/blazin.svg';
import checkIn from 'assets/img/landing/check-in.svg';
import prizes from 'assets/img/landing/prizes.svg';
import section_bg from 'assets/img/landing/how_to_play_bg.svg';
import {TilesSectionWrapper, TilesTitle, TilesWrapper} from './styles';
import styled from 'styled-components';

const STilesSectionWrapper = styled(TilesSectionWrapper)`
  background: #FFFFFF url(${section_bg}) no-repeat 50% 50%;
  > div {
	width: 90%;
  }

  ${TilesWrapper} > div {
	min-width: 33%;
	display: flex;
	justify-content: center;
  }
`

export const HowToPlaySection: React.FC = () => (
	<STilesSectionWrapper>
		<TilesTitle>here's how you compete to win</TilesTitle>
		<TilesWrapper>
			<LandingTile icon={blazin} text="Pick your teams and props for the week.">
				PLAY OUR <span>GAMES</span>
			</LandingTile>
			<LandingTile icon={checkIn} text="Make sure you check-in at your local Buffalo Wild Wings.">
				<span>Check-In <br/></span> at the bar
			</LandingTile>
			<LandingTile icon={prizes} text="Trips, food and more">
				win <br/> <span>prizes</span>
			</LandingTile>
		</TilesWrapper>
	</STilesSectionWrapper>
);
